import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './ForgotPassword.css'; // Updated CSS file
 
export default function ForgotPassword() {
  const { userId, token } = useParams(); // Extract userId and token from the URL
  const navigate = useNavigate(); // For navigation after password reset
 
  // States for the password fields and messages
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
 
  const handlePasswordChange = (e) => {
    setNewPassword(e.target.value);
  };
 
  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };
 
  const handlePasswordReset = async (e) => {
    e.preventDefault();
 
    // Check if passwords match
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
 
    // Reset error message
    setError("");
 
    try {
      const res = await fetch(`https://backend.ems.hiradentallab.com/api/user/resetpasswordhr/${userId}/${token}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ newPassword }), // Send the new password
      });
 
      const data = await res.json();
 
      if (res.ok) {
        setMessage("Password reset successful!");
        // Redirect to sign-in page after a successful password reset
        setTimeout(() => {
          navigate('/'); // Redirect to Signin page after 2 seconds
        }, 2000);
      } else {
        setMessage(data.message || "Failed to reset password.");
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      setMessage("Failed to reset password. Please try again later.");
    }
  };
 
  return (
    <div className="password-reset-container">
      <div className="password-reset-card">
        <h2 className="password-reset-title">Reset Your Password</h2>
        <p className="password-reset-text">Enter your new password below.</p>
                {/* Show error or success messages */}
        {error && <div className="message error">{error}</div>}
        {message && <div className="message success">{message}</div>}
        <form onSubmit={handlePasswordReset}>
          <div className="auth-input-group">
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={handlePasswordChange}
              placeholder="Enter your new password"
              required
              minLength="6"
              className="auth-input"
            />
          </div>
          <div className="auth-input-group">
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
              placeholder="Confirm your new password"
              required
              minLength="6"
              className="auth-input"
            />
          </div>
          <button type="submit" className="auth-submit-button">Reset Password</button>
        </form>
 
 
      </div>
    </div>
  );
}
 